module.exports = __webpack_public_path__ + "img/advantages-3.ab76fc4a.svg";